import { styled } from '@mui/material';
import { CoreDialog, CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  contentBody: {
    padding: '0 1rem 1.5rem',
  },
};

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '12px',
    maxWidth: '576px',
    width: '100%',
  },
}));

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  padding: '1rem',
  textAlign: 'center',

  [theme.breakpoints.up('sm')]: {
    padding: '2rem 2rem 1.25rem',
  },
}));
